import { RazorLayout } from "../../components/razor-reuse";
import React, { useContext, useEffect, useState } from "react";
import SideMenuComp from "./SideMenuComp";
import "../../styles/layout/DashboardLayout.css";
import ActionContext from "../../context/ActionContext";
import { ALL_ICONS } from "../../assets/icons/AllIcons";
import HeaderNav from "./HeaderNav";
import NoContentPage from "./no-content/NoContentPage";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedInUser } from "../../redux/userAuth";
import RootState from "../../redux/type";
import { getAllCurrencies } from "../../redux/settings";
import EndSessionModal from "../../pages/dashboard/settings/account/modals/EndSessionModal";
import EndSessionTokenModal from "../../pages/dashboard/settings/account/modals/EndSessionTokenModal";
import NotificationDrawer from "./NotificationDrawer";

interface myComponentProps {
  children?: React.ReactNode;
  back?: boolean;
  loading?: boolean;
  onBack?: () => void;
  title?: string;
}

const DashboardLayoutMain = ({
  children,
  back,
  onBack,
  title,
  loading,
}: myComponentProps) => {
  const actionCtx = useContext(ActionContext);
  const dispatch = useDispatch();
  const { user, loading_user } = useSelector((state: RootState) => state.auth);

  const { all_currencies_drop } = useSelector(
    (state: RootState) => state.settings
  );

  const [modal, setModal] = useState(false);

  useEffect(() => {
    if (Object?.keys(user)?.length < 1) {
      dispatch(getLoggedInUser({}) as any);
    }

    if (all_currencies_drop?.length < 1) {
      dispatch(getAllCurrencies({} as any) as any);
    }
  }, [dispatch]);
  // }, [all_currencies_drop?.length, dispatch, user]); // removing this to prevent rerendering

  return (
    <>
      {" "}
      <RazorLayout
        className="smart-send-dashboard-layout-wrapper"
        collapse={actionCtx?.collapse}
        onClickCollapse={() => {
          actionCtx?.setCollapse && actionCtx?.setCollapse();
        }}
        collapseColor="rgba(115, 71, 146, 1)"
        sideMenuWidth={`23rem`}
        sideMenuCollapseWidth={`6.5rem`}
        // showMobileMenu={collapseVals}
        // setShowMobileMenu={() => {
        //   setCollapseVals(!collapseVals);
        // }}
        headerNavHeight={`6.5rem`}
        logo={actionCtx?.collapse ? ALL_ICONS?.collapse_logo : ALL_ICONS?.logo}
        collapsible={true}
        sideMenuComponent={<SideMenuComp />}
        headerNavComponent={
          <HeaderNav
            back={back}
            onBack={onBack}
            title={title}
            handleNotify={() => setModal(true)}
          />
        }
      >
        {loading || loading_user ? (
          <>
            <NoContentPage loading={loading || loading_user} />
          </>
        ) : (
          <>{children}</>
        )}
      </RazorLayout>
      <EndSessionModal visible={actionCtx?.logout} />
      <EndSessionTokenModal visible={actionCtx?.sessionEnd} />
      <NotificationDrawer
        open={modal}
        onClose={() => {
          setModal(false);
        }}
      />
    </>
  );
};

export default DashboardLayoutMain;
